module.exports = __webpack_public_path__ + "static/img/down-corner-8m-x-2m-inverted_256.ea758bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/down-corner-8m-x-2m-inverted_256.png
// module id = FVZr
// module chunks = 0